<script>
const allLogos = [
	'/logos/logo-1.png',
	'/logos/logo-2.png',
	'/logos/logo-3.png',
	'/logos/logo-4.png',
	'/logos/logo-5.png',
	'/logos/logo-6.png',
	'/logos/logo-7.png',
	'/logos/logo-8.png',
	'/logos/logo-9.png',
	'/logos/logo-10.png',
	'/logos/logo-11.png',
	'/logos/logo-12.png',
	'/logos/logo-13.png',
	'/logos/logo-14.png',
	'/logos/logo-15.png',
	'/logos/logo-16.png'
]

export default {
	data() {
		return {
			displayedLogos: allLogos.slice(0, 8),
			intervalId: null,
			currentLogoIndex: 0,
			isReplacing: false
		}
	},
	methods: {
		// פונקציה להחלפת לוגו אחד בכל פעם
		replaceOneLogo() {
			const availableLogos = allLogos.filter(logo => !this.displayedLogos.includes(logo))
			if (availableLogos.length === 0) return
			const randomAvailableLogo = availableLogos[Math.floor(Math.random() * availableLogos.length)]
			const newLogos = this.displayedLogos.slice()
			newLogos[this.currentLogoIndex] = randomAvailableLogo
			this.displayedLogos = newLogos
			this.currentLogoIndex = (this.currentLogoIndex + 1) % 8
		},
		// פונקציה לביצוע מחזור החלפה מלא
		performReplacementCycle() {
			if (this.isReplacing) return
			this.isReplacing = true
			let replacementCount = 0

			const replacementInterval = setInterval(() => {
				this.replaceOneLogo()
				replacementCount++

				// לאחר החלפת כל 8 הלוגואים, עצור והמתן 4 שניות
				if (replacementCount >= 8) {
					clearInterval(replacementInterval)
					setTimeout(() => {
						this.isReplacing = false
					}, 4000)
				}
			}, 100)
		}
	},
	mounted() {
		// התחל מחזור החלפה ראשון מיד
		this.performReplacementCycle()

		// חזור על מחזור ההחלפה כל 5 שניות (0.8 שניות החלפה + 4 שניות המתנה)
		this.intervalId = setInterval(() => {
			this.performReplacementCycle()
		}, 5000)
	},
	beforeDestroy() {
		if (this.intervalId !== null) {
			clearInterval(this.intervalId)
		}
	}
}
</script>

<template>
	<div class="bg-gray-light ">
		<div class="grid grid-wrap-8 gap-0 w1100px m_px-1 m_grid-wrap-4 m_gap-col-05 m_gap-row-0 m_pt-1">
			<div
				v-for="(logo, index) in displayedLogos"
				:key="logo + '-' + index"
				class="h40px transition-400 justify-content-center logo-item  txt-center"
			>
				<img
					:src="logo"
					:alt="`Logo ${index + 1}`"
					class="logo-img h40px contain"
				>
			</div>
		</div>
	</div>
</template>

<style scoped>
/* אנימציה רכה כשהלוגואים מתחלפים - כמו באתר Wiz */
.logo-item {
	animation: slideUpFade 0.6s ease-out;
	overflow: hidden;
}

@keyframes slideUpFade {
	0% {
		opacity: 0;
		transform: translateY(20px);
	}
	60% {
		opacity: 0.8;
		transform: translateY(-2px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.contain {
	object-fit: contain;
}
</style>
